import {
	type FetchResponseOfError,
	getOrdersOrderIdProtocolsDocument,
	type ProtocolDocumentResponseDto,
} from "Infrastructure/Api/Api";
import {
	ApiCallError,
	getMessageFromErrorResponse,
} from "Infrastructure/Api/ApiUtils";
import { useQuery } from "@tanstack/react-query";

export const getOrderProtocolDocumentQueryKey = (orderId: number) => [
	"ORDER_PROTOCOL_DOCUMENT",
	orderId,
];

export function useOrderProtocolDocumentQuery(orderId?: number) {
	return useQuery({
		queryKey: getOrderProtocolDocumentQueryKey(orderId!),
		queryFn: async (): Promise<ProtocolDocumentResponseDto | null> => {
			const response = await getOrdersOrderIdProtocolsDocument(orderId!);
			// 404 is not typed in the generated response union.
			const status: number = response.status;

			// The order simply has no protocol yet - not an error for the widget.
			if (status === 404) {
				return null;
			}

			if (status !== 200) {
				throw new ApiCallError(
					getMessageFromErrorResponse(response),
					response as FetchResponseOfError,
				);
			}

			return response.data as ProtocolDocumentResponseDto;
		},
		refetchInterval: false,
		refetchIntervalInBackground: false,
		enabled: !!orderId,
	});
}
